import { AlertLineReportDTO } from "src/models/alert-line-report/alert-line-report-dto";
import { AlertLineReportSTO } from "src/models/alert-line-report/alert-line-report-sto";
import { BaseApiService } from "../base";

export class AlertLineReportApiService extends BaseApiService<AlertLineReportDTO, AlertLineReportSTO> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineReports",
      saveItemsPath: "/SaveAlertLineReports",
    });
  }
}
